import React, { useState, Children, isValidElement, cloneElement } from 'react';
import { CarouselSnappedSlide, CarouselSnapped } from '@andes/carousel-snapped';
import { CarouselFreeSlide, CarouselFree } from '@andes/carousel-free';
import classNames from 'classnames';
import { v4 } from 'uuid';
import { EshopsComponentsTitles, Section, Action } from '@mshops-components-library/common';
import { Card } from '@andes/card';
import { Button } from '@andes/button';
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
var REACT_ELEMENT_TYPE$1;
function _createRawReactElement$1(e, r, E, l) {
  REACT_ELEMENT_TYPE$1 || (REACT_ELEMENT_TYPE$1 = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
const Asset = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    d: "M8.27686 4.34644L7.42834 5.19496L12.224 9.99059L7.42334 14.7912L8.27187 15.6397L13.921 9.99059L8.27686 4.34644Z",
    fill: color
  }));
};
var _ChevronRight;
var SHOP_TYPE_ESHOPS = ['eshop', 'seller', 'super', 'super_partner', 'brand', 'landing'];
const RecommendationsContainer = /*#__PURE__*/function () {
  const RecommendationsContainer = function RecommendationsContainer(_ref) {
    var _EshopsComponentsTitl, _h;
    var children = _ref.children,
      display = _ref.display,
      highlightSeeds = _ref.highlight_seeds,
      title = _ref.title,
      type = _ref.type,
      viewMoreAction = _ref.view_more_action,
      categories = _ref.categories,
      updateGrid = _ref.updateGrid,
      showTitle = _ref.show_title,
      eshopType = _ref.eshopType,
      deviceType = _ref.deviceType,
      useChevron = _ref.useChevron,
      trackingId = _ref.trackingId;
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      categoryId = _useState2[0],
      setCategoryId = _useState2[1];
    var hasCategory = Boolean(categories === null || categories === void 0 ? void 0 : categories.length);
    var isEshops = SHOP_TYPE_ESHOPS.includes(eshopType);
    var sectionHeaderClassName = classNames("section-header section-header__".concat(display), {
      'section-header__title-container': hasCategory
    });
    var rowContainerClassName = classNames('row container', {
      'highlight-seeds': highlightSeeds
    });
    var categoriesClassName = classNames({
      'section-center': hasCategory,
      'ui-ms-section-eshops': isEshops,
      'ui-ms-section-eshops--seller': eshopType === 'seller' || eshopType === 'brand' || eshopType === 'landing',
      'ui-ms-section-eshops--super': eshopType === null || eshopType === void 0 ? void 0 : eshopType.includes('super')
    });
    var titleClassName = classNames('section-header__title--base', {
      'section-header__title': hasCategory
    });
    var eshopContainerClassName = classNames('section-eshop__title--layout', {
      'section-eshop__title': hasCategory
    });
    var addTrackUrl = function addTrackUrl(baseUrl) {
      var encodedPlaceholder = '%7Btracking_id%7D';
      var encodedTrackingId = encodeURIComponent(trackingId !== null && trackingId !== void 0 ? trackingId : "");
      return baseUrl.replace(encodedPlaceholder, encodedTrackingId);
    };
    if (viewMoreAction && viewMoreAction.target) {
      viewMoreAction.target = addTrackUrl(viewMoreAction.target);
    }
    var updateSubHeader = function updateSubHeader(category) {
      setCategoryId(category);
      updateGrid(category);
    };
    var validateSelectedCategory = function validateSelectedCategory(index, id) {
      return categoryId === id || index === 0 && !categoryId;
    };
    var setDecoration = function setDecoration(index, id) {
      return classNames({
        'section-header__sub-header-decoration': validateSelectedCategory(index, id)
      });
    };
    var NewAction = function NewAction(props) {
      var shouldRenderChevron = deviceType === 'mobile' && isEshops && useChevron && eshopType !== 'landing';
      if (shouldRenderChevron) {
        return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
          label: null,
          isSelf: true
        }), _ChevronRight || (_ChevronRight = /*#__PURE__*/_createRawReactElement$1(Asset, {})));
      }
      return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
        isSelf: true
      }));
    };
    var showTitles = function showTitles() {
      return typeEshop(eshopType) ? _EshopsComponentsTitl || (_EshopsComponentsTitl = /*#__PURE__*/_createRawReactElement$1(EshopsComponentsTitles, {
        title: title,
        showTitle: showTitle,
        deviceType: deviceType,
        titleClassName: titleClassName
      })) : _h || (_h = /*#__PURE__*/_createRawReactElement$1("h2", {
        className: titleClassName
      }, void 0, title));
    };
    return /*#__PURE__*/_createRawReactElement$1(Section, {
      type: type,
      className: categoriesClassName,
      eshopType: eshopType
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
      className: rowContainerClassName
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
      className: isEshops ? eshopContainerClassName : sectionHeaderClassName
    }, void 0, showTitles(), !hasCategory && viewMoreAction && /*#__PURE__*/React.createElement(NewAction, viewMoreAction)), hasCategory && /*#__PURE__*/_createRawReactElement$1("div", {
      className: "section__sub-header"
    }, void 0, categories.map(function (item, index) {
      return /*#__PURE__*/_createRawReactElement$1("h3", {
        onClick: function onClick() {
          return updateSubHeader(item.id);
        },
        className: setDecoration(index, item.id)
      }, v4(), item.label);
    })), children));
  };
  RecommendationsContainer.defaultProps = {
    display: 'original',
    highlight_seeds: false,
    view_more_action: null,
    show_title: true,
    eshopType: null,
    type: '',
    useChevron: true
  };
  return RecommendationsContainer;
}();
var RecommendationsContainer$1 = RecommendationsContainer;
var LinkItemWrapper = 'div';
var namespace = 'ui-eshop-see-more-card';
var SeeMoreCard = function SeeMoreCard(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    isPurchaseMinQuantityLabel = _ref.isPurchaseMinQuantityLabel,
    viewMoreAction = _ref.viewMoreAction,
    isAddToCartVisible = _ref.isAddToCartVisible;
  var minSalesClassNames = classNames('ui-eshop-card__min-sales', {
    'ui-eshop-card__min-sales--hidden': !isPurchaseMinQuantityLabel
  });
  var cardContainerClassNames = classNames("".concat(namespace, "__container"), {
    'with-min-sales': isPurchaseMinQuantityLabel,
    'with-add-to-cart': isAddToCartVisible
  });
  return /*#__PURE__*/_createRawReactElement$1(Card, {
    shadow: "elevated",
    className: namespace
  }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
    className: cardContainerClassNames
  }, void 0, /*#__PURE__*/_createRawReactElement$1(LinkItemWrapper, {
    className: "".concat(namespace, "__content")
  }, void 0, /*#__PURE__*/_createRawReactElement$1("img", {
    src: icon,
    alt: label,
    className: "".concat(namespace, "__image")
  }), /*#__PURE__*/_createRawReactElement$1("p", {
    className: "".concat(namespace, "__text")
  }, void 0, label)), /*#__PURE__*/_createRawReactElement$1("div", {
    className: "".concat(namespace, "__button-container")
  }, void 0, /*#__PURE__*/_createRawReactElement$1(Button, {
    className: "".concat(namespace, "-button"),
    hierarchy: "loud",
    size: "medium",
    href: viewMoreAction.target,
    type: "link"
  }, void 0, viewMoreAction.label), isPurchaseMinQuantityLabel && /*#__PURE__*/_createRawReactElement$1("span", {
    className: minSalesClassNames
  }))));
};
SeeMoreCard.defaultProps = {};
var SeeMoreCard$1 = SeeMoreCard;
var CONFIG_BY_DEVICE = {
  CAROUSEL: {
    desktop: {
      slidesPerView: 5,
      thresholdSlide: 0,
      spacing: 12,
      arrows: true
    },
    mobile: {
      slidesPerView: 2,
      thresholdSlide: 20,
      spacing: 0,
      arrows: false
    }
  },
  IMAGE_SIZE: {
    desktop: '224',
    mobile: '160'
  }
};
const SnappedCollection = /*#__PURE__*/function () {
  const SnappedCollection = function SnappedCollection(props) {
    var deviceType = props.deviceType,
      cartInfo = props.cart_info,
      children = props.children,
      seeElements = props.seeElements,
      items = props.items,
      isFreeCarousel = props.isFreeCarousel,
      overrideCarouselSettings = props.overrideCarouselSettings,
      seeMoreCard = props.see_more_card,
      viewMoreAction = props.view_more_action,
      userZipCode = props.userZipCode;
    var _ref = cartInfo || {},
      _ref$cart_error_snack = _ref.cart_error_snackbar_label,
      cartErrorSnackbarLabel = _ref$cart_error_snack === void 0 ? 'No se pudo actualizar la cantidad.' : _ref$cart_error_snack,
      _ref$cart_text_label = _ref.cart_text_label,
      cartTextLabel = _ref$cart_text_label === void 0 ? 'en tu carrito' : _ref$cart_text_label,
      _ref$cta = _ref.cta,
      cta = _ref$cta === void 0 ? 'Agregar al carrito' : _ref$cta,
      _ref$cta_for_multiple = _ref.cta_for_multiple_variations,
      variationsCta = _ref$cta_for_multiple === void 0 ? 'Elegir opciones' : _ref$cta_for_multiple;
    var imgSize = CONFIG_BY_DEVICE.IMAGE_SIZE[deviceType];
    var carouselSettings = _objectSpread2(_objectSpread2({
      pagination: false
    }, CONFIG_BY_DEVICE.CAROUSEL[deviceType]), overrideCarouselSettings);
    var hasFreeOrPromisedShippingItem = items === null || items === void 0 ? void 0 : items.some(function (_ref2) {
      var shipping = _ref2.shipping;
      return (shipping === null || shipping === void 0 ? void 0 : shipping.promise) || (shipping === null || shipping === void 0 ? void 0 : shipping.fulfillment);
    });
    var isPurchaseMinQuantityLabel = items === null || items === void 0 ? void 0 : items.some(function (_ref3) {
      var saleTerms = _ref3.sale_terms;
      return saleTerms === null || saleTerms === void 0 ? void 0 : saleTerms.purchase_min_quantity_label;
    });
    var isAddToCartVisible = (seeElements === null || seeElements === void 0 ? void 0 : seeElements.action_card) && !!userZipCode;
    var freeCarouselSettings = {
      pagination: false,
      spacing: 12,
      id: 'free-carousel'
    };
    var cardExtraProps = {
      cta: cta,
      variationsCta: variationsCta,
      cartErrorSnackbarLabel: cartErrorSnackbarLabel,
      cartTextLabel: cartTextLabel,
      imgSize: imgSize,
      seeElements: seeElements,
      hasFreeOrPromisedShippingItem: hasFreeOrPromisedShippingItem,
      isPurchaseMinQuantityLabel: isPurchaseMinQuantityLabel,
      shouldHaveAutoHeight: isPurchaseMinQuantityLabel ? false : hasFreeOrPromisedShippingItem
    };
    var seeMoreCardComponent = isFreeCarousel && deviceType !== 'desktop' ? /*#__PURE__*/_createRawReactElement$1(CarouselFreeSlide, {}, void 0, /*#__PURE__*/React.createElement(SeeMoreCard$1, _extends({}, seeMoreCard, {
      isPurchaseMinQuantityLabel: isPurchaseMinQuantityLabel,
      viewMoreAction: viewMoreAction,
      isAddToCartVisible: isAddToCartVisible
    }))) : /*#__PURE__*/_createRawReactElement$1(CarouselSnappedSlide, {}, void 0, /*#__PURE__*/React.createElement(SeeMoreCard$1, _extends({}, seeMoreCard, {
      isPurchaseMinQuantityLabel: isPurchaseMinQuantityLabel,
      viewMoreAction: viewMoreAction,
      isAddToCartVisible: isAddToCartVisible
    })));
    var freeCarouselComponents = Children.map(children, function (child) {
      if (/*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/_createRawReactElement$1(CarouselFreeSlide, {}, void 0, /*#__PURE__*/cloneElement(child, cardExtraProps));
      }
      return null;
    });
    var snappedCarouselComponents = Children.map(children, function (child) {
      if (/*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/_createRawReactElement$1(CarouselSnappedSlide, {}, "slide-id-".concat(child.key), /*#__PURE__*/cloneElement(child, _objectSpread2(_objectSpread2({}, cardExtraProps), {}, {
          key: "slide-child-id-".concat(child.key)
        })));
      }
      return null;
    });
    var shouldShowSeeMoreCard = (seeMoreCard === null || seeMoreCard === void 0 ? void 0 : seeMoreCard.show_see_more_card) && (deviceType === 'Desktop' ? children.length >= 5 : children.length >= 3);
    var freeCarouselChildren = seeMoreCard && shouldShowSeeMoreCard ? [].concat(_toConsumableArray(freeCarouselComponents), [seeMoreCardComponent]) : freeCarouselComponents;
    var snappeCarouselChildrens = seeMoreCard && shouldShowSeeMoreCard ? [].concat(_toConsumableArray(snappedCarouselComponents), [seeMoreCardComponent]) : snappedCarouselComponents;
    var snapCarouselComponent = function snapCarouselComponent() {
      return /*#__PURE__*/React.createElement(RecommendationsContainer$1, props, /*#__PURE__*/React.createElement(CarouselSnapped, carouselSettings, snappeCarouselChildrens));
    };
    var freeCarouselComponent = function freeCarouselComponent() {
      return /*#__PURE__*/React.createElement(RecommendationsContainer$1, props, /*#__PURE__*/React.createElement(CarouselFree, freeCarouselSettings, freeCarouselChildren));
    };
    return isFreeCarousel && deviceType !== 'desktop' ? freeCarouselComponent() : snapCarouselComponent();
  };
  SnappedCollection.defaultProps = {
    show_title: true,
    cart_info: {
      cta: ''
    },
    overrideCarouselSettings: {}
  };
  return SnappedCollection;
}();
var SnappedCollection$1 = SnappedCollection;
export { SnappedCollection$1 as SnappedCollection, RecommendationsContainer$1 as SnappedCollectionContainer };
